import React, { FC, useCallback, memo } from 'react'
import { Badge } from '@wmgtech/legato'

import { BadgeTagListProps } from './BadgeTagList.props'

import './BadgeTagList.scss'

const BadgeTagList: FC<BadgeTagListProps> = memo(({ tags, activeTagsIds, onToggleTag, setShowAlert }) => {
  const onToggleTagHandler = useCallback(
    (tag, active) => () =>
      onToggleTag(tag, active).then(() =>
        setShowAlert({
          title: 'Success',
          type: 'success',
          message: (
            <>
              Tag <b>{tag.label}</b> has been successfully {active ? 'unassigned' : 'assigned'}
            </>
          )
        })
      ),
    [onToggleTag, setShowAlert]
  )

  return (
    <div className="tag-badge">
      {tags.map((tag) => {
        const isActive = activeTagsIds.includes(tag.id)

        return (
          <div onClick={onToggleTagHandler(tag, isActive)} key={tag.id}>
            <Badge
              className="tag-badge__item"
              text={tag.label}
              colorType={isActive ? 'dark' : 'white'}
              containerStyle={isActive ? 'solid' : 'outline'}
              size="sm"
            />
          </div>
        )
      })}
    </div>
  )
})

export default BadgeTagList
